import asCanvasElement from '../../utils/CanvasElement';
import ImageElement from './ImageElement';
import type { ImageElementProps } from './types';

export type { ImageElementProps };
export default asCanvasElement(ImageElement);
